// Sentry browser SDK initialization. Must be imported before React so the
// router integration can wrap the browser tracing hooks.
import { useEffect } from 'react'
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom'
import * as Sentry from '@sentry/react'

const dsn = import.meta.env['VITE_SENTRY_DSN'] as string | undefined
const agentUrl =
  (import.meta.env['VITE_AGENT_URL'] as string | undefined) ?? 'http://127.0.0.1:3001'

if (dsn) {
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    release: import.meta.env['VITE_APP_VERSION'] as string | undefined,
    // Leave sendDefaultPii OFF: with it enabled Sentry attaches cookies
    // (including the Supabase auth cookie) and form-field values to every
    // event. Use `Sentry.setUser({ id: userId })` from the auth store after
    // a successful sign-in instead.
    sendDefaultPii: false,
    integrations: [
      Sentry.reactRouterV7BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    // Propagate sentry-trace + baggage to our agent so browser → server
    // spans stitch into a single trace.
    tracePropagationTargets: ['localhost', '127.0.0.1', agentUrl, /^\//],
    tracesSampleRate: import.meta.env.PROD ? 0.2 : 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    enableLogs: true,
  })
  window.Sentry = Sentry
}
